module.exports = __webpack_public_path__ + "img/glovo.bbaf934e.svg";